import {Injectable} from "@angular/core";
import {UserSession} from "../interfaces/domain/UserSession";
import {GlobalConfig} from "../configs/GlobalConfig";
import {User} from "../interfaces/rest/User";

declare let pendo: any;

@Injectable({
  providedIn: 'root',
})
export class PendoService {

  constructor() {
    // empty
  }

  initializePendo(userSession: UserSession, user: User): void {
    if(!pendo) {
      console.warn('No pendo function available');
    }
    else {
      let accountId: string = `${GlobalConfig.environment}_SealedAir`;
      let accountName: string = `Sealed Air (${GlobalConfig.environment})`;
      let clientName: string|undefined = undefined;
      let lastAuthenticated = user.lastLoggedOn;

      if(user.company) {
        clientName = user.company.companyName!;
        accountId = `${GlobalConfig.environment}_${clientName.replaceAll(" ", "")}`;
        accountName = `${clientName} (${GlobalConfig.environment})`;
      }

      const pendoConfig = {
        account: {
          id: accountId,
          accountName: accountName,
        },
        visitor: {
          id: `${GlobalConfig.environment}_${userSession.userId}`,
          email: userSession.email,
          firstName: userSession.firstName,
          lastName: userSession.lastName,
          role: userSession.roles ? userSession.roles[0] : '',
          environment: GlobalConfig.environment,
          userType: userSession.userType,
          languageCode: userSession.languageCode,
          clientName: clientName,
          lastAuthenticated: lastAuthenticated,
        }
      };

      pendo.initialize(pendoConfig);

      console.log(`Pendo initialized.`);
    }
  }
}
